<template>
		<div id="pageRoot">

			<p id="text01">
				Ordena las letras y escribe los nombres.
			</p>
			<p id="text02">
				SILLA
			</p>

			<!-- TEXT ----------------------------------------------------------------------------------------------------->
			<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01"/>
			<!-- TEXT ----------------------------------------------------------------------------------------------------->

			<div id="chair" class="basicItem01">		
				<img src="/pages/img/sordo/svgPage60Chair.svg" class="pageElement" style=" width: 100%; height: 100%;">
			</div>
			<div id="table" class="basicItem01">		
				<img src="/pages/img/sordo/svgPage63Table.svg" class="pageElement" style=" width: 100%; height: 100%;">
			</div>

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<span class="footer-page footer-write"></span>
			<div class="pageSVG">
				<img src="/pages/img/sordo/svgPage60.svg" class="pageElement" style=" width: 100%; height: auto;">
			</div>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
#chair 
{
position: absolute;
left: 78.03%;
right: 6.35%;
top: 19.4%;
bottom: 53.86%;
}
#table
{
position: absolute;
left: 75.78%;
right: 7.51%;
top: 50.39%;
bottom: 31.68%;
}
#inputField01
{
	width:430px;
	margin-left: 29%;
	margin-top: 36%;
	font-size: 45px;
	position:absolute;
	z-index: 3;
}
#text01{
/* Ordena las letras y escribe los nombres. */

position: absolute;
left: 8.59%;
right: 47.56%;
top: 16.02%;
bottom: 79.43%;
margin:0px;
z-index: 3;

font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;

color: #000000;

}

#text02
{
/* SILLA */

position: absolute;
left: 44.14%;
right: 44.14%;
top: 26.56%;
bottom: 64.97%;
margin:0px;
z-index: 3;

font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 48px;
line-height: 65px;

color: #2BB673;
}


</style>
<script>
export default {
  data() {
    return {
      videos: ["p60/V28.mp4", "p60/V29.mp4", "p60/V30.mp4"]
    }
  }
}
</script>